// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content__ZEZdM","notfound":"notfound_notfound__ox4sq","code":"notfound_code__lAHdb","text":"notfound_text__GSriF","boto":"notfound_boto__cDDS1"};